// These are dbo.UserRole primary keys, not an arbitrary sequence: AddStaffDialog filters
// User.userRoleId by them and AdminCreateUserPage compares them to UserRole.id off the API, so a
// member whose value does not exist in the table silently matches nothing. Give every new member
// its real Id explicitly rather than letting it auto-increment off the one above.
export enum UserRoles {
    Admin = 1,
    ProspectManager = 2,
    ProjectCoordinator = 3,
    HRAdmin = 4,
    HR = 5,
    AccountingAdmin = 6,
    Accounting = 7,
    Landman = 8,
    // KNOWN MISMATCH: these three are 1001/1002/1003 in dbo.UserRole. Harmless so far only
    // because nothing compares them to a userRoleId - they are reached through the JWT role
    // claim, which JwtHelper maps by role NAME, never by Id. Do not add a DB-id comparison
    // against them without correcting the values first.
    Cartographer = 9,
    ContractorSuper = 10,
    ClientUser = 11
}

export default class UserRole {
    id: number;
    role: string;
    isActive?: boolean;
}



// WEBPACK FOOTER //
// ./src/models/UserRole.ts